import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, CreditCard, Truck, ShieldCheck, Lock } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const Checkout25 = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', phone: '',
        address: '', city: '', state: '', pincode: '',
        paymentMethod: 'card',
        cardNumber: '', cardExpiry: '', cardCvv: '', cardName: '',
    });

    const steps = [
        { num: 1, label: 'Shipping', icon: Truck },
        { num: 2, label: 'Payment', icon: CreditCard },
        { num: 3, label: 'Confirm', icon: ShieldCheck },
    ];

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px', border: '1px solid #DEE2E6',
        background: '#FFFFFF', fontSize: 14, outline: 'none',
        fontFamily: 'IBM Plex Sans, sans-serif', color: '#111111',
        transition: 'border-color 0.2s',
        borderRadius: 0
    };

    const labelStyle = {
        display: 'block', fontSize: 12, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: 8, color: '#111111',
        fontFamily: 'Space Grotesk, sans-serif'
    };

    const orderItems = [
        { name: 'Classic Cotton Kurta', size: 'M', qty: 1, price: 3499, image: 'https://images.pexels.com/photos/8310281/pexels-photo-8310281.jpeg?auto=compress&cs=tinysrgb&w=200' },
        { name: 'Structured Nehru Jacket', size: 'L', qty: 1, price: 6500, image: 'https://images.pexels.com/photos/9558577/pexels-photo-9558577.jpeg?auto=compress&cs=tinysrgb&w=200' },
    ];

    const subtotal = orderItems.reduce((s, i) => s + i.price * i.qty, 0);

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-co * { box-sizing: border-box; }
                .sahaj-co { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-co-heading { font-family: 'Space Grotesk', sans-serif; }
                .sahaj-co input:focus, .sahaj-co select:focus { border-color: #0D7C66 !important; }
            `}</style>
            <div className="sahaj-co" style={{ minHeight: '100vh' }}>
                <Header />

                <div style={{ maxWidth: 1280, margin: '0 auto', padding: '100px 24px 80px' }}>
                    <h1 className="sahaj-co-heading" style={{
                        fontSize: 40, fontWeight: 700, marginBottom: 48, letterSpacing: '-1px'
                    }}>
                        CHECKOUT
                    </h1>

                    {/* Step Indicator */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 48, maxWidth: 600 }}>
                        {steps.map((step, idx) => (
                            <React.Fragment key={step.num}>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}
                                    onClick={() => step.num < currentStep && setCurrentStep(step.num)}
                                >
                                    <div style={{
                                        width: 44, height: 44, display: 'flex', alignItems: 'center',
                                        justifyContent: 'center',
                                        background: currentStep >= step.num ? '#0D7C66' : '#F8F9FA',
                                        color: currentStep >= step.num ? '#FFFFFF' : '#6C757D',
                                        border: currentStep >= step.num ? 'none' : '1px solid #DEE2E6',
                                        transition: 'all 0.3s'
                                    }}>
                                        {currentStep > step.num ? <Check size={18} /> : <step.icon size={18} />}
                                    </div>
                                    <span className="sahaj-co-heading" style={{
                                        fontSize: 14, fontWeight: 600,
                                        color: currentStep >= step.num ? '#111111' : '#6C757D',
                                        textTransform: 'uppercase', letterSpacing: '1px'
                                    }}>
                                        {step.label}
                                    </span>
                                </div>
                                {idx < steps.length - 1 && (
                                    <div style={{
                                        flex: 1, height: 2, margin: '0 16px',
                                        background: currentStep > step.num ? '#0D7C66' : '#DEE2E6',
                                        transition: 'background 0.3s'
                                    }} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 400px', gap: 48 }}>
                        {/* Form Area */}
                        <div>
                            {/* Step 1: Shipping */}
                            {currentStep === 1 && (
                                <div>
                                    <h2 className="sahaj-co-heading" style={{
                                        fontSize: 24, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px'
                                    }}>
                                        Shipping Information
                                    </h2>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                                        <div>
                                            <label style={labelStyle}>First Name</label>
                                            <input name="firstName" value={formData.firstName} onChange={handleInput} style={inputStyle} placeholder="Enter first name" />
                                        </div>
                                        <div>
                                            <label style={labelStyle}>Last Name</label>
                                            <input name="lastName" value={formData.lastName} onChange={handleInput} style={inputStyle} placeholder="Enter last name" />
                                        </div>
                                        <div>
                                            <label style={labelStyle}>Email</label>
                                            <input name="email" type="email" value={formData.email} onChange={handleInput} style={inputStyle} placeholder="your@email.com" />
                                        </div>
                                        <div>
                                            <label style={labelStyle}>Phone</label>
                                            <input name="phone" value={formData.phone} onChange={handleInput} style={inputStyle} placeholder="+91 XXXXX XXXXX" />
                                        </div>
                                        <div style={{ gridColumn: '1 / -1' }}>
                                            <label style={labelStyle}>Address</label>
                                            <input name="address" value={formData.address} onChange={handleInput} style={inputStyle} placeholder="Street address, apartment, suite" />
                                        </div>
                                        <div>
                                            <label style={labelStyle}>City</label>
                                            <input name="city" value={formData.city} onChange={handleInput} style={inputStyle} placeholder="City" />
                                        </div>
                                        <div>
                                            <label style={labelStyle}>State</label>
                                            <select name="state" value={formData.state} onChange={handleInput} style={{ ...inputStyle, cursor: 'pointer' }}>
                                                <option value="">Select state</option>
                                                {['Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat', 'Rajasthan', 'West Bengal', 'Telangana', 'Kerala', 'Uttar Pradesh'].map(s => (
                                                    <option key={s} value={s}>{s}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label style={labelStyle}>PIN Code</label>
                                            <input name="pincode" value={formData.pincode} onChange={handleInput} style={inputStyle} placeholder="XXXXXX" />
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setCurrentStep(2)}
                                        style={{
                                            marginTop: 32, padding: '16px 48px', background: '#0D7C66',
                                            color: '#FFFFFF', border: 'none', fontSize: 14, fontWeight: 700,
                                            cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '2px',
                                            fontFamily: 'Space Grotesk, sans-serif',
                                            transition: 'background 0.2s'
                                        }}
                                        onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                        onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                    >
                                        Continue to Payment →
                                    </button>
                                </div>
                            )}

                            {/* Step 2: Payment */}
                            {currentStep === 2 && (
                                <div>
                                    <h2 className="sahaj-co-heading" style={{
                                        fontSize: 24, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px'
                                    }}>
                                        Payment Method
                                    </h2>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 32 }}>
                                        {[
                                            { value: 'card', label: 'Credit / Debit Card' },
                                            { value: 'upi', label: 'UPI Payment' },
                                            { value: 'cod', label: 'Cash on Delivery' },
                                        ].map(method => (
                                            <label
                                                key={method.value}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: 12,
                                                    padding: '16px 20px',
                                                    border: formData.paymentMethod === method.value ? '2px solid #0D7C66' : '1px solid #DEE2E6',
                                                    background: formData.paymentMethod === method.value ? '#E8F5F1' : '#FFFFFF',
                                                    cursor: 'pointer', transition: 'all 0.2s'
                                                }}
                                            >
                                                <input
                                                    type="radio" name="paymentMethod" value={method.value}
                                                    checked={formData.paymentMethod === method.value}
                                                    onChange={handleInput}
                                                    style={{ accentColor: '#0D7C66' }}
                                                />
                                                <span className="sahaj-co-heading" style={{ fontSize: 14, fontWeight: 600 }}>
                                                    {method.label}
                                                </span>
                                            </label>
                                        ))}
                                    </div>

                                    {formData.paymentMethod === 'card' && (
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                                            <div style={{ gridColumn: '1 / -1' }}>
                                                <label style={labelStyle}>Card Number</label>
                                                <input name="cardNumber" value={formData.cardNumber} onChange={handleInput} style={inputStyle} placeholder="XXXX XXXX XXXX XXXX" />
                                            </div>
                                            <div style={{ gridColumn: '1 / -1' }}>
                                                <label style={labelStyle}>Name on Card</label>
                                                <input name="cardName" value={formData.cardName} onChange={handleInput} style={inputStyle} placeholder="Full name" />
                                            </div>
                                            <div>
                                                <label style={labelStyle}>Expiry</label>
                                                <input name="cardExpiry" value={formData.cardExpiry} onChange={handleInput} style={inputStyle} placeholder="MM/YY" />
                                            </div>
                                            <div>
                                                <label style={labelStyle}>CVV</label>
                                                <input name="cardCvv" type="password" value={formData.cardCvv} onChange={handleInput} style={inputStyle} placeholder="***" />
                                            </div>
                                        </div>
                                    )}

                                    {formData.paymentMethod === 'upi' && (
                                        <div>
                                            <label style={labelStyle}>UPI ID</label>
                                            <input style={inputStyle} placeholder="yourname@upi" />
                                        </div>
                                    )}

                                    <div style={{ display: 'flex', gap: 16, marginTop: 32 }}>
                                        <button
                                            onClick={() => setCurrentStep(1)}
                                            style={{
                                                padding: '16px 32px', background: '#FFFFFF', color: '#111111',
                                                border: '1px solid #DEE2E6', fontSize: 14, fontWeight: 600,
                                                cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif',
                                                textTransform: 'uppercase', letterSpacing: '1px'
                                            }}
                                        >
                                            ← Back
                                        </button>
                                        <button
                                            onClick={() => setCurrentStep(3)}
                                            style={{
                                                padding: '16px 48px', background: '#0D7C66', color: '#FFFFFF',
                                                border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                                textTransform: 'uppercase', letterSpacing: '2px',
                                                fontFamily: 'Space Grotesk, sans-serif',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                            onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                        >
                                            Review Order →
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Step 3: Confirm */}
                            {currentStep === 3 && (
                                <div>
                                    <h2 className="sahaj-co-heading" style={{
                                        fontSize: 24, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px'
                                    }}>
                                        Review & Confirm
                                    </h2>

                                    <div style={{ background: '#F8F9FA', padding: 24, border: '1px solid #DEE2E6', marginBottom: 24 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                            <h3 className="sahaj-co-heading" style={{ fontSize: 14, fontWeight: 600, margin: 0, textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                Shipping Address
                                            </h3>
                                            <button onClick={() => setCurrentStep(1)} style={{ background: 'none', border: 'none', color: '#0D7C66', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                                                Edit
                                            </button>
                                        </div>
                                        <p style={{ fontSize: 14, color: '#6C757D', lineHeight: 1.6, margin: 0 }}>
                                            {formData.firstName || 'John'} {formData.lastName || 'Doe'}<br />
                                            {formData.address || '123 Main Street'}<br />
                                            {formData.city || 'Mumbai'}, {formData.state || 'Maharashtra'} - {formData.pincode || '400001'}<br />
                                            Phone: {formData.phone || '+91 98765 43210'}
                                        </p>
                                    </div>

                                    <div style={{ background: '#F8F9FA', padding: 24, border: '1px solid #DEE2E6', marginBottom: 32 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                            <h3 className="sahaj-co-heading" style={{ fontSize: 14, fontWeight: 600, margin: 0, textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                Payment Method
                                            </h3>
                                            <button onClick={() => setCurrentStep(2)} style={{ background: 'none', border: 'none', color: '#0D7C66', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                                                Edit
                                            </button>
                                        </div>
                                        <p style={{ fontSize: 14, color: '#6C757D', margin: 0 }}>
                                            {formData.paymentMethod === 'card' ? 'Credit/Debit Card' : formData.paymentMethod === 'upi' ? 'UPI Payment' : 'Cash on Delivery'}
                                        </p>
                                    </div>

                                    <div style={{ display: 'flex', gap: 16 }}>
                                        <button
                                            onClick={() => setCurrentStep(2)}
                                            style={{
                                                padding: '16px 32px', background: '#FFFFFF', color: '#111111',
                                                border: '1px solid #DEE2E6', fontSize: 14, fontWeight: 600,
                                                cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif',
                                                textTransform: 'uppercase', letterSpacing: '1px'
                                            }}
                                        >
                                            ← Back
                                        </button>
                                        <button
                                            onClick={() => navigate('/template25/orders')}
                                            style={{
                                                padding: '16px 48px', background: '#0D7C66', color: '#FFFFFF',
                                                border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                                display: 'flex', alignItems: 'center', gap: 10,
                                                textTransform: 'uppercase', letterSpacing: '2px',
                                                fontFamily: 'Space Grotesk, sans-serif',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                            onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                        >
                                            <Lock size={16} />
                                            Place Order
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Order Summary Sidebar */}
                        <div>
                            <div style={{ background: '#F8F9FA', padding: 32, border: '1px solid #DEE2E6', position: 'sticky', top: 100 }}>
                                <h2 className="sahaj-co-heading" style={{
                                    fontSize: 18, fontWeight: 700, marginBottom: 24,
                                    textTransform: 'uppercase', letterSpacing: '1px'
                                }}>
                                    Your Order
                                </h2>
                                {orderItems.map((item, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex', gap: 12, marginBottom: 16,
                                        paddingBottom: 16, borderBottom: '1px solid #DEE2E6'
                                    }}>
                                        <div style={{ width: 64, height: 64, overflow: 'hidden', flexShrink: 0 }}>
                                            <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <h4 className="sahaj-co-heading" style={{ fontSize: 13, fontWeight: 600, margin: '0 0 4px' }}>{item.name}</h4>
                                            <p style={{ fontSize: 12, color: '#6C757D', margin: '0 0 4px' }}>Size: {item.size} × {item.qty}</p>
                                            <p className="sahaj-co-heading" style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>₹{item.price.toLocaleString('en-IN')}</p>
                                        </div>
                                    </div>
                                ))}
                                <div style={{ paddingTop: 8 }}>
                                    {[
                                        { label: 'Subtotal', value: `₹${subtotal.toLocaleString('en-IN')}` },
                                        { label: 'Shipping', value: 'Free' },
                                        { label: 'Tax', value: `₹${Math.round(subtotal * 0.05).toLocaleString('en-IN')}` },
                                    ].map((row, idx) => (
                                        <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, fontSize: 14 }}>
                                            <span style={{ color: '#6C757D' }}>{row.label}</span>
                                            <span style={{ fontWeight: 500 }}>{row.value}</span>
                                        </div>
                                    ))}
                                    <div style={{
                                        borderTop: '2px solid #111111', marginTop: 12, paddingTop: 16,
                                        display: 'flex', justifyContent: 'space-between'
                                    }}>
                                        <span className="sahaj-co-heading" style={{ fontSize: 16, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>Total</span>
                                        <span className="sahaj-co-heading" style={{ fontSize: 24, fontWeight: 700 }}>
                                            ₹{(subtotal + Math.round(subtotal * 0.05)).toLocaleString('en-IN')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Checkout25;
